import { Guid, Nillable } from '@web/utils';
import { QuantityUnit } from '@web/shared/module/measurement';
import { WarehouseGoodType } from '../enums/warehouse-good-type';

export class AdminWarehouseGoodCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      type: WarehouseGoodType;
      quantity: number;
      quantityUnit: QuantityUnit;
      sku: string;
      name: string;
      createdAt: Date;
      brand: string;
      brandId: Guid;
      localization?: Nillable<string>;
      localizationId?: Nillable<Guid>;
      promotion: boolean;
      durabilityInformation?: Nillable<string>;
      measure?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get type(): WarehouseGoodType {
    return this.data.type;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get quantityUnit(): QuantityUnit {
    return this.data.quantityUnit;
  }

  public get sku(): string {
    return this.data.sku;
  }

  public get name(): string {
    return this.data.name;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get brand(): string {
    return this.data.brand;
  }

  public get brandId(): Guid {
    return this.data.brandId;
  }

  public get localization(): Nillable<string> {
    return this.data.localization;
  }

  public get localizationId(): Nillable<Guid> {
    return this.data.localizationId;
  }

  public get promotion(): boolean {
    return this.data.promotion;
  }

  public get durabilityInformation(): Nillable<string> {
    return this.data.durabilityInformation;
  }

  public get measure(): Nillable<string> {
    return this.data.measure;
  }
}
